module.exports = __webpack_public_path__ + "img/favicon.ae2b972.png";